<div *ngIf="!display_mode || display_mode === 'col'" class="card-1">
  <div *ngIf="meeting">
    <div class="date">
      <span class="circle" [ngClass]="meetingGroup()"></span>
      <span *ngIf="meeting.begin_at">{{ dateStringToDate(meeting.begin_at) | dfnsFormat: 'LLLL dd, yyyy' }}</span>
      <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg" class="arrow">
        <path
          d="M13.244 4.513L9.254 8.503L8.827 8.062C8.73367 7.96867 8.69633 7.87533 8.715 7.782C8.73833 7.68867 8.78967 7.6 8.869 7.516L10.878 5.521C10.99 5.409 11.095 5.30867 11.193 5.22C11.291 5.13133 11.3867 5.04967 11.48 4.975C11.2467 5.00767 10.9993 5.03333 10.738 5.052C10.4813 5.07067 10.2153 5.08 9.94 5.08H0.826V3.939H9.94C10.2153 3.939 10.4837 3.94833 10.745 3.967C11.0063 3.98567 11.2537 4.01133 11.487 4.044C11.3937 3.96933 11.2957 3.88767 11.193 3.799C11.095 3.71033 10.99 3.61 10.878 3.498L8.855 1.489C8.771 1.405 8.71967 1.31633 8.701 1.223C8.68233 1.12967 8.71733 1.03633 8.806 0.943L9.24 0.495L13.244 4.513Z"
          fill="#6D7381"/>
      </svg>
      <span *ngIf="meeting.begin_at">{{ dateStringToDate(meeting.begin_at) | dfnsFormat: 'HH:mm' }}</span>

    </div>
    <div class="content" [ngClass]="meetingGroup()" (click)="showMore()">
      <div class="card-info">
      <div class="card-image">
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <div class="card-content">
        <div class="subject">{{ meetingSubject }}</div>
        <div class="link" *ngIf="metingType">{{ 'event-calendar.types.' + metingType | customLocale }}</div>
      </div>
      </div>
      <div class="title">
        <app-meeting-title [meeting]="meeting"></app-meeting-title>
      </div>
    </div>
  </div>
</div>

<ng-template [ngIf]="display_mode ==='row' && meeting">
  <ng-template [ngIf]="deviceService.isDesktop()" [ngIfThen]="card" [ngIfElse]="mobileCard"></ng-template>
</ng-template>

<!-- Templates -->

<ng-template #card>
  <div class="card-2 content">
    <div class="date">
      <div class="circle" [ngClass]="meetingGroup()"></div>
      <span *ngIf="meeting.begin_at">{{ dateStringToDate(meeting.begin_at) | dfnsFormat: 'LLLL dd, yyyy' }}</span>
    </div>
    <div class="body" [ngClass]="meetingGroup()">
      <div class="slide">
        <div class="card-cover" (click)="showMore()"></div>
        <ng-container *ngTemplateOutlet="typeTemplate"></ng-container>
        <div class="cover">
          <on-ui-cover [cover]="cover"></on-ui-cover>
        </div>
        <div class="info-block">
          <div class="">
            <div class="subject">{{ meetingSubject }}</div>
            <div class="title">{{ meeting.title }}</div>
            <ng-container *ngTemplateOutlet="stats"></ng-container>
          </div>
          <div class="action-wrap">
            <ng-container *ngTemplateOutlet="meetingIs('owner') ? authorRef : participantRef"></ng-container>
            <div class="btns-holder">
              <on-ui-button *ngIf="!paidInProcess"
                            label="teacher-card.actions.more-details"
                            class="transparent"
                            (onclick)="showMore()">
              </on-ui-button>

              <on-ui-button *ngIf="meetingCan('open')"
                            label="dashboard.label-btn.enter-class"
                            class="transparent"
                            (onclick)="redirectToJoin()">
              </on-ui-button>
            </div>
          </div>
        </div>

        <div class="menu-actions">
          <ng-container *ngTemplateOutlet="menu"></ng-container>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="meetingFooter"></ng-container>
      <ng-container *ngTemplateOutlet="contractFooter"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #mobileCard>
  <div class="schedule-mini" [ngClass]="meetingGroup()">
    <div class="date">
      <div class="circle" [ngClass]="meetingGroup()"></div>
      <span class="label"
            *ngIf="meeting.begin_at">{{ dateStringToDate(meeting.begin_at) | dfnsFormat: 'LLLL dd, yyyy' }}</span>
    </div>
    <div class="header">
      <div class="cover-wrap">
        <ng-container *ngTemplateOutlet="typeTemplate"></ng-container>
        <on-ui-cover [cover]="cover"></on-ui-cover>
      </div>
      <div class="info-block">
        <span class="subject">{{ meetingSubject }}</span>
        <h5 class="title">{{ meeting?.title }}</h5>
      </div>
      <div class="menu-actions">
        <ng-container *ngTemplateOutlet="menu"></ng-container>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="stats"></ng-container>
    <div class="action-wrap">
      <ng-container *ngTemplateOutlet="meetingIs('owner') ? authorRef : participantRef"></ng-container>
      <div class="btns-holder">
        <on-ui-button label="teacher-card.actions.more-details"
                      class="transparent"
                      (onclick)="showMore()">
        </on-ui-button>

        <on-ui-button *ngIf="meetingCan('open')"
                      [label]="'dashboard.label-btn.enter-class' | customLocale"
                      class="transparent"
                      (onclick)="redirectToJoin()">
        </on-ui-button>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="meetingFooter"></ng-container>
    <ng-container *ngTemplateOutlet="contractFooter"></ng-container>
  </div>
</ng-template>

<ng-template #typeTemplate>
  <div class="type" [ngClass]="metingType">{{ 'event-calendar.types.' + metingType | customLocale }}</div>
</ng-template>

<ng-template #meetingFooter>
  <div class="footer" *ngIf="showMeetingFooter" [class.processing]="processing">
    <div class="text-wrap" [class.reservation]="isMeetingReservationCountdown">
      <div *ngIf="meetingActionTitle" class="text">{{ meetingActionTitle | customLocale }}</div>

      <div *ngIf="paidInProcess" class="text">{{ 'dashboard.meeting_reservation_waiting' | customLocale }}</div>

      <div *ngIf="meetingIs('rescheduling')" class="text new-date">
        <span class="label">{{ 'meetings.reschedule_date' | customLocale }}</span>
        <span>{{ rescheduleBeginDate | dfnsFormat: 'do LLL yyyy k:mm' }} &mdash;
          {{ rescheduleEndDate | dfnsFormat: 'HH:mm' }}</span>
      </div>

      <div *ngIf="isMeetingReservationCountdown" class="text timeleft">
        {{ 'meetings.reservation_time_left' | customLocale }}
        <app-countdown [date]="meetingReservationExpireDate"
                       [minTitle]="'dashboard.time-in-minute-countdown'">
        </app-countdown>
      </div>
    </div>

    <div class="actions" [class.processing]="processing">
      <spinner2 *ngIf="processing; else notProcessing"></spinner2>

      <ng-template #notProcessing>
        <div *ngIf="meetingCan('paidJoin')" class="action-item">
          <on-ui-button rel="paidJoin"
                        label="dashboard.label-btn.proceed-to-checkout"
                        class="secondary"
                        (onclick)="redirectToJoin()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('withdrawInvitation')" class="action-item">
          <on-ui-button rel="withdrawInvitation"
                        label="dashboard.label-btn.withdraw-invitation"
                        class="danger outline"
                        (onclick)="withdrawInvitation()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('declineInvitation')" class="action-item">
          <on-ui-button rel="declineInvitation"
                        label="dashboard.label-btn.decline"
                        class="danger link decline"
                        (onclick)="declineInvitation()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('paidAcceptInvitation')" class="action-item">
          <on-ui-button rel="paidAcceptInvitation"
                        label="dashboard.label-btn.accept-and-pay"
                        [state]="hasCrossEvents ? 'fail' : 'default'"
                        class="secondary"
                        (onclick)="paidAcceptInvitation()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('acceptInvitation')" class="action-item">
          <on-ui-button rel="acceptInvitation"
                        label="dashboard.label-btn.accept"
                        [state]="hasCrossEvents ? 'fail' : 'default'"
                        class="primary"
                        (onclick)="acceptInvitation()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('rejectReschedule')" class="action-item reject">
          <span rel="rejectReschedule"
                (click)="openDeclineScheduleAlert()">
            {{'dashboard.label-btn.reject' | customLocale}}
          </span>
        </div>
        <div *ngIf="meetingCan('acceptReschedule')" class="action-item">
          <on-ui-button rel="acceptReschedule"
                        label="dashboard.label-btn.confirm"
                        class="primary"
                        (onclick)="acceptReschedule()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('withdrawReschedule')" class="action-item">
          <on-ui-button rel="withdrawReschedule"
                        label="dashboard.label-btn.cancel"
                        class="danger outline"
                        (onclick)="withdrawReschedule()">
          </on-ui-button>
        </div>
        <div *ngIf="meetingCan('withdrawReschedule')" class="action-item">
          <on-ui-button rel="withdrawReschedule"
                        label="dashboard.label-btn.waiting"
                        class="poutline">
          </on-ui-button>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #contractFooter>
  <div class="footer contract" *ngIf="showContractFooter">
    <div class="text-wrap">
      <div *ngIf="contractActionTitle" class="text bold">{{ contractActionTitle | customLocale }}</div>

      <div class="text next-date" *ngIf="!contract?.is?.suspended">
        <div class="label">{{'meetings.next_meeting' | customLocale}}</div>
        <div class="date">{{ dateStringToDate(meeting.begin_at) | dfnsFormat: 'dd LLL yyyy HH:mm' }}</div>
      </div>

      <div *ngIf="!contract?.is?.suspended" class="text timeleft">
        {{ 'meetings.reservation_time_left' | customLocale }}
        <app-countdown [date]="contractReservationExpireDate"
                       [minTitle]="'dashboard.time-in-minute-countdown'"
                       (timeIsOver)="onTimeOver()">
        </app-countdown>
      </div>
    </div>

    <div class="actions">
      <spinner2 *ngIf="processing; else notProcessing"></spinner2>

      <ng-template #notProcessing>
        <div *ngIf="contractCan('setup_payments')" class="action-item">
          <on-ui-button rel="paidJoin"
                        [label]="contractSetupPaymentsTitle"
                        class="secondary"
                        (onclick)="openContractPaymentsSetupForm()">
          </on-ui-button>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #menu>
  <div class="copy-informer" [class.active]="state.copied"><span>{{'invite-card.link-copied' | customLocale}}</span></div>
  <on-ui-card-menu>
    <a class="menu-item warn" *ngIf="meeting?.purl" [href]="meeting.purl">[⚠️] Panel [meeting]</a>
    <a class="menu-item warn" *ngIf="meeting?.user_service?.purl" [href]="meeting.user_service.purl">[⚠️] Panel [service]</a>
    <a class="menu-item warn" *ngIf="meeting?.user_service_contract?.purl" [href]="meeting.user_service_contract.purl">[⚠️] Panel [contract]</a>
    <div class="menu-item"
         *ngIf="meetingCan('edit')"
         (click)="openMeetingForm()">{{ 'meetings.menu-edit' | customLocale }}</div>
    <div class="menu-item"
         *ngIf="meetingCan('reschedule')"
         (click)="onReschedule()">{{ 'meetings.menu-reschedule' | customLocale }}</div>
    <div class="menu-item" #shareLinkRef>
      <button type="button"
              ngxClipboard
              [cbContent]="meetingUrl"
              (cbOnSuccess)="onCopied()"
              [container]="shareLinkRef">{{ 'meetings.menu-share' | customLocale }}<!-- Поделиться --></button>
    </div>
    <div class="menu-item"
         *ngIf="meetingCan('invite')"
         (click)="openInviteModal()">{{ 'meetings.menu-invite' | customLocale }}<!--Пригласить--></div>
    <div class="menu-item"
         *ngIf="meetingIs('finished') && !isMe()"
         (click)="openComplaintModal()">{{ 'meetings.menu-complain' | customLocale }}<!--Пожаловаться--></div>
    <div class="menu-item danger"
         *ngIf="contractCan('break')"
         (click)="openBreakAlert()">{{ 'meetings.menu-break-contract' | customLocale }}<!--Отменить рег услугу--></div>
    <div class="menu-item danger"
         *ngIf="meetingCan('leave') || meetingCan('leaveWithPenalty')"
         (click)="leaveMeeting()">{{ 'meetings.menu-leave-meeting' | customLocale }}<!--Покинуть--></div>
    <div class="menu-item danger"
         *ngIf="meetingCan('cancel') || meetingCan('cancelWithPenalty')"
         (click)="cancelMeeting()">{{ 'meetings.menu-cancel-meeting' | customLocale }}<!--Отменить--></div>
  </on-ui-card-menu>
</ng-template>

<ng-template #authorRef>
  <div class="author-block">
    <ng-template [ngIf]="isSingleMeeting && student">
      <span class="label">{{'meetings.student'| customLocale}}</span>
      <div class="avatar-wrap" [routerLink]="profileUrl(student)">
        <on-ui-cover [cover]="avatar"></on-ui-cover>
      </div>
      <span class="author-name" [routerLink]="profileUrl(student)">{{ getUserFullName(student) }}</span>
    </ng-template>

    <ng-template [ngIf]="isGroupMeeting">
      <span class="label" *ngIf="isGroupMeeting">{{'meetings.group_meeting' | customLocale}}</span>
    </ng-template>

    <span *ngIf="!isMeVersion()" class="chat-action" (click)="onOpenChat()">{{'meetings.write-to-chat' | customLocale}}</span>
  </div>
</ng-template>

<ng-template #participantRef>
  <div class="author-block">
    <span class="label">{{'meetings.tutor' | customLocale}}</span>
    <div class="avatar-wrap" [routerLink]="profileUrl(author)">
      <on-ui-cover [cover]="avatar"></on-ui-cover>
    </div>
    <span class="author-name" [routerLink]="profileUrl(author)">
      {{ getUserFullName(author) }}
    </span>
    <span *ngIf="!isMeVersion()" class="chat-action" (click)="onOpenChat()">{{'meetings.write-to-chat' | customLocale}}</span>
  </div>
</ng-template>

<ng-template #stats>
  <div class="stats">
    <span class="stat-item">
      <ng-template [ngIf]="isSingleMeeting">{{ 'event-calendar.participants-limit.private' | customLocale }}</ng-template>
      <ng-template [ngIf]="isGroupMeeting">{{ 'event-calendar.participants-limit.group' | customLocale }}</ng-template>
    </span>
    <span class="stat-item"
          *ngIf="meeting.begin_at">{{ dateStringToDate(meeting.begin_at) | dfnsFormat: 'dd LLLL yyyy HH:mm' }}</span>
    <span class="stat-item">{{ differenceInMinutes() }} {{ 'meetings.join.min' | customLocale }}</span>
    <span class="stat-item">{{ 'teacher-card.stats.classes' | customLocale }} {{ classes() | customLocale }}</span>
    <span class="stat-item" *ngIf="contractIs('ongoing')">Classes per week: {{ userService?.options?.meetings_limit }}</span>
  </div>
</ng-template>

<!-- Modals -->

<app-modal *ngIf="deviceService.isDesktop() && state.inviteModal" [schedule]="true" [canClose]="false"
           (closed)="closeInviteModal()">
  <app-modal-body>
    <app-invite-to-meeting [meeting]="meeting"></app-invite-to-meeting>
  </app-modal-body>
</app-modal>

<ng-template [ngIf]="meetingCheckoutDialogOpened">
  <app-meeting-checkout-wizard-dialog
    [meetingId]="meeting.id"
    _succeed="onPaymentSucceed()"
    (closed)="closeMeetingCheckoutDialog()"
  ></app-meeting-checkout-wizard-dialog>
</ng-template>

<app-user-service-contract-checkout-dialog
  *ngIf="serviceCheckoutDialogOpened"
  (closed)="closeServiceCheckoutDialog()"
  (succeed)="onContractPaymentSucceed()"
  [userServiceContractId]="contract.id">
</app-user-service-contract-checkout-dialog>

<ng-template [ngIf]="state.meetingFormModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileMeetingForm"
             [canClose]="false"
             (closed)="closeMeetingForm()">
    <app-modal-body>
      <app-meeting-form-wrapper [meetingId]="meeting.id" [caller]="'app-schedule-mini'"></app-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="closeMeetingForm()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | customLocale }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-meeting-form-wrapper [meetingId]="meeting.id" [caller]="'app-schedule-mini'"></app-meeting-form-wrapper>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>

<ng-template [ngIf]="state.complaintForm">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileComplainForm"
             (closed)="closeComplaintForm()">
    <app-modal-body>
      <app-complaint-meeting-form [meeting]="meeting" [author]="author"></app-complaint-meeting-form>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileComplainForm>
    <app-mobile-modal (closed)="closeComplaintForm()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | customLocale }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-complaint-meeting-form [meeting]="meeting" [author]="author"></app-complaint-meeting-form>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>

<app-alert *ngIf="declineRescheduleAlert" type="warning">
  <ng-container alert-title>{{ 'dashboard.reschedule.alert-title' | customLocale }}</ng-container>
  <ng-container alert-body>{{ 'dashboard.reschedule.alert-body' | customLocale }}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="dashboard.label-btn.close"
                  rel="closeDeclineRescheduleAlert"
                  class="poutline"
                  (onclick)="closeDeclineRescheduleAlert()">
    </on-ui-button>
    <on-ui-button label="dashboard.label-btn.reject"
                  rel="rejectReschedule"
                  class="danger"
                  (onclick)="rejectReschedule()">
    </on-ui-button>
  </ng-container>
</app-alert>

<app-alert *ngIf="classBreakAlertShow && alertData" type="warning">
  <ng-container alert-title>{{alertData.title | customLocale}}</ng-container>
  <ng-container alert-body>{{alertData.description | customLocale}}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="{{alertData.closeBtnText}}"
                  class="poutline"
                  (onclick)="classBreakAlertShow = false">
    </on-ui-button>
    <on-ui-button label="{{alertData.confirmBtnText}}"
                  class="primary"
                  (onclick)="breakContract()">
    </on-ui-button>
  </ng-container>
</app-alert>

<app-alert *ngIf="state.confirmationAlert && state.confirmationOptions"
           [type]="state.confirmationOptions.type">
  <ng-container alert-title>{{state.confirmationOptions.title | customLocale}}</ng-container>
  <ng-container alert-body>{{state.confirmationOptions.description | customLocale}}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button label="{{ state.confirmationOptions.close_button_text }}"
                  class="poutline"
                  (onclick)="closeConfirmationAlert()">
    </on-ui-button>
    <on-ui-button label="{{ state.confirmationOptions.confirm_button_text }}"
                  class="primary"
                  (onclick)="confirm()">
    </on-ui-button>
  </ng-container>
</app-alert>
